import { useDisclosure } from "@chakra-ui/react"
import { ReactNode, createContext, useContext } from "react"
import { FromCohort, PathItem } from "../../path/sync/types"
import {
  ItemSyncStatus,
  StepPublishStatus,
  useGetPublishStatus,
  useGetSyncStatus
} from "./utils"

type PublishContextType = {
  publishStatus: StepPublishStatus
  syncStatus: ItemSyncStatus
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
  item?: PathItem
  cohort?: FromCohort
  resource?: any
  onLaunchSync?: () => void
  onOpenStep?: () => void
}

const PublishContext = createContext<PublishContextType>(
  {} as PublishContextType
)

export const usePublish = () => useContext(PublishContext)

type PublishProviderProps = {
  children: ReactNode
  item: PathItem
  cohort: FromCohort
  onLaunchSync?: () => void
  onOpenStep?: () => void
}

const StepPublishProvider = ({
  children,
  item,
  cohort,
  onLaunchSync,
  onOpenStep
}: PublishProviderProps) => {
  const { isOpen, onClose, onOpen } = useDisclosure()

  const resource = cohort.resource

  const syncStatus = useGetSyncStatus(item, cohort)

  const publishStatus = useGetPublishStatus(item, cohort)

  const publishValue = {
    isOpen,
    onClose,
    onOpen,
    item,
    cohort,
    resource,
    syncStatus,
    publishStatus,
    onLaunchSync,
    onOpenStep
  }

  return (
    <PublishContext.Provider value={publishValue}>
      {children}
    </PublishContext.Provider>
  )
}

export default StepPublishProvider
